import React from 'react';
import DocsList from 'features/docs/components/DocsList';
import { Tabs, Tab } from 'shared/ui/Tabs';
import ProductsList from 'features/products/components/products/ProductsList';
import { formatDate, formatPhone } from 'shared/utils/format';

const SupplierItem = ({ item }) => {
  return (
    <>
      {/* Header Section */}
      <div className='mb-6'>
        <div className='flex justify-between items-start'>
          <h1 className='text-2xl font-normal mb-1'>{item.name}</h1>
          <span className='text-gray-400'>Поставщик</span>
        </div>
        <div className='text-sm mb-2'>
          Создан {formatDate(item.created)}
        </div>
        {item.products?.meta?.size > 0 && (
          <div className='flex gap-2'>
            <span className='bg-blue-500 text-white text-sm px-2 py-1 rounded'>
              Товаров: {item.products.meta.size}
            </span>
          </div>
        )}
      </div>

      {/* Contacts Section */}
      {item.phone && (
        <div className='mb-6'>
          <h2 className='text-lg font-medium mb-2'>КОНТАКТЫ</h2>
          <div className='flex items-center gap-2'>
            <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' />
            </svg>
            <span>{formatPhone(item.phone)}</span>
          </div>
        </div>
      )}

      {/* Tabs Section */}
      <div>
        <Tabs initialTab='products'>
          <Tab key='products' label='Товары'>
            <ProductsList supplier={item.meta} />
          </Tab>
          <Tab key='docs' label='Документы'>
            <DocsList supplier={item.meta} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default SupplierItem;